import React from 'react';
import styles from './Toggle.module.scss';
import SVG from 'react-inlinesvg';
import { icons } from '@/school-management/utils/icons';
import Button from '../Button/Button';
import { Link } from 'react-router-dom';

interface ToggleSwitchProps {
  onChange?: (value: any) => void;
  checked?: boolean;
  value?: string;
  options?: { label: string; value: string }[];
  subTitle?: string;
  label?: string;
  linkTo?: string;
  buttonText?: string;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  onChange,
  checked = true,
  value,
  options,
  subTitle,
  label,
  linkTo,
  buttonText,
}) => {
  // Segmented Toggle Mode
  if (options && options.length > 0 && value !== undefined) {
    return (
      <div className={styles.toggleWrapper}>
        {label && (
          <div className={styles.Label}>
            <div className={styles.toggleLabel}>{label}</div>
          </div>
        )}
        <div className={styles.segmentedToggle}>
          {options.map(option => (
            <button
              key={option.value}
              type='button'
              className={`${styles.toggleButton} ${value === option.value ? styles.active : ''}`}
              onClick={() => onChange?.(option.value)}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>
    );
  }

  // Classic Toggle Mode
  const handleToggle = () => {
    const newChecked = !checked;
    onChange?.(newChecked);
  };

  return (
    <div className={styles.toggleWrapper}>
      <div className={styles.Label}>
        {label && <div className={styles.toggleLabel}>{label}</div>}
        {subTitle && <div className={styles.SubLabel}>{subTitle}</div>}
      </div>
      <label className={styles.switch}>
        {linkTo ? (
          <Link to={linkTo} style={{ textDecoration: 'none' }}>
            <Button className={styles.button} style={{ height: '44px' }}>
              {buttonText}
            </Button>
          </Link>
        ) : (
          <>
            <input type='checkbox' checked={checked} onChange={handleToggle} />
            <SVG
              className={styles.checkboxImage}
              src={checked ? icons['toggleOn'] : icons['toggleOff']}
            />
          </>
        )}
      </label>
    </div>
  );
};

export default ToggleSwitch;
